import React, { useState, useRef } from 'react';
import './Gallery.css';

const Gallery = ({ itemInfo, closeGallery, startIndex }) => {
    const [currentIndex, setCurrentIndex] = useState(startIndex);
    const touchStartX = useRef(null);
    const touchEndX = useRef(null);

    const goNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex < itemInfo.media.length - 1 ? prevIndex + 1 : 0
        );
    };

    const goPrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : itemInfo.media.length - 1
        );
    };

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (touchStartX.current !== null && touchEndX.current !== null) {
            const distance = touchStartX.current - touchEndX.current;
            const swipeThreshold = 50; // minimum distance to be considered swipe

            if (distance > swipeThreshold) goNext(); // swiped left
            else if (distance < -swipeThreshold) goPrev(); // swiped right
        }

        // reset
        touchStartX.current = null;
        touchEndX.current = null;
    };

    const selectImage = (index) => {
        setCurrentIndex(index);
    };

    return (
        <div
            className="gallery"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            <div className="gallery-image-container">
                <img
                    src={itemInfo.media[currentIndex]}
                    alt="Gallery"
                    className="main-image"
                />
                <button className="gallery-arrow left" onClick={goPrev}>
                    &#10094;
                </button>
                <button className="gallery-arrow right" onClick={goNext}>
                    &#10095;
                </button>
                <button className="closeGallery" onClick={closeGallery}>
                    X
                </button>
            </div>

            <div className="gallery-thumbnails">
                {itemInfo.media.map((image, index) => (
                    <img
                        key={index}
                        src={image}
                        alt="Thumbnail"
                        className={`thumbnail ${
                            index === currentIndex ? 'active' : ''
                        }`}
                        onClick={() => selectImage(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default Gallery;
